<template>
  <div class="site-footer__main vue-comp critical-component-clear">
    <div class="site-footer__main-menu">
      <accordion-items
        id="FooterAccordion"
        v-slot="{item}"
        class="site-footer__accordion"
        :items="menus"
        scroll-to
        section="site-footer"
        :expand-all="!isMobile || isTablet"
        container-size-classes="site-footer__menu"
        button-class="site-footer__control button"
      >
        <site-footer-menu
          v-if="item"
          :item="item"
        />
      </accordion-items>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Site footer (site-footer)
 * -----------------------------------------------------------------------------
 * Site footer component with social links.
 * - Static section.
 *
 */
import { mapState } from 'vuex'
import AccordionItems from '~global/accordion/accordion-items'
import SiteFooterMenu from '~async/site-footer-group/site-footer/site-footer-menu.vue'
export default {
  name: 'SiteFooter',

  components: {
    AccordionItems,
    SiteFooterMenu,
  },

  props: {
    contactMenu: {
      type: [Boolean, Object],
      default: null,
    },
    footerMenu: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
      breakpoint: (state) => state.index.screen.breakpoint,
    }),

    /**
     * Compute menus
     */
    menus() {
      if (!this.contactMenu) {
        return this.footerMenu
      }

      const menus = this.footerMenu
      menus.push(this.contactMenu)
      return menus
    },

    isTablet() {
      return this.breakpoint === 'm'
    },
  },

  mounted() {
    // not empty
  },
}
</script>

<style lang="scss">
@import './site-footer';
</style>
